import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import { Switch, useLocation, Route } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Formacao from './pages/Formacao';
import About from './pages/About';
import Events from './pages/Events';
import Library from './pages/Library';
import Services from './pages/Services';
import './styles/transitions.css';
import { useSelector } from 'react-redux';
import { RootState } from '../src/redux/store';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/globalStyles';
import NotFound from './pages/NotFound';
import ScrollToTop from './Utils/ScrollToTop';

function App() {
  const colors = useSelector(({ theme }: RootState) => theme.theme);

  const location = useLocation();

  return (
    <main>
      <ThemeProvider theme={colors}>
        <ScrollToTop />

        <Header />
        {/* <TransitionGroup class="main">
          <CSSTransition
            key={location.key}
            classNames="transition"
            timeout={300}
          > */}
        <Switch location={location}>
          <Route exact path="/" component={Home} />
          <Route path="/sobre" component={About} />
          <Route path="/events" component={Events} />
          <Route path="/servicos" component={Services} />
          <Route path="/biblioteca" component={Library} />

          {/* <Route exact path="/" component={Events} /> */}
          <Route path="/contato" component={Contact} />
          <Route path="/formacao" component={Formacao} />

          <Route path="*" component={NotFound} />
        </Switch>
        {/* </CSSTransition>
        </TransitionGroup> */}
        <Footer />
        <GlobalStyle />
      </ThemeProvider>
    </main>
  );
}

export default App;
